<template>
    <popup :opened="dataToShow" @close="close">
        <!-- BEGIN Content modal add hobbie -->
        <div v-if="dataToShow">
            <div class="my-5 mx-5 lg:my-15 lg:mx-10 2xl:my-20 2xl:mx-15">
                <h3 class="mb-10">Choisir une icône pour {{hobbieToEdit.value}}</h3>
                <p class="text-indigo-600 mb-8 text-center">Choisir une icône parmi la liste ci-dessous</p>
                
                <div v-if="hobbieToEdit.icon && hobbieToEdit.icon != ''" class="mb-8 flex flex-col items-center justify-center space-y-1 text-base">
                    <div>Icône actuelle</div>
                    <icon :name="hobbieToEdit.icon" class="text-indigo-600 h-10 w-10" />
                    <div @click="removeIcon" class="text-pink-600 cursor-pointer">Supprimer l'icône</div>
                </div>
                
                <div class="flex flex-col justify-center items-center">
                    <div v-if="listIcons && listIcons.length > 0" class="grid grid-cols-6 md:grid-cols-10 lg:grid-cols-12 gap-10 justify-center">
                        <div 
                            v-for="(icon, i) in listIcons" 
                            :key="i"
                            class="col-span-1 cursor-pointer"
                            @click="chooseIcon(icon)" 
                        >
                            <icon :name="icon" class="text-indigo-600 w-max transform duration-150 hover:scale-150" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </popup>
</template>

<script>
import Popup from '../../../components/Popup.vue';
import Icon from  '../../../components/Icon.vue';
import InputText from '../../../components/Inputs/InputText.vue';
import InputSelect from '../../../components/Inputs/InputSelect.vue';
import DatePicker from '../../../components/Inputs/DatePicker.vue';
import ActionButton from '../../../components/ActionButton.vue';

import Constants from './../../../constants';

export default {
  components:{
    Popup,
    Icon,
    InputText,
    InputSelect,
    DatePicker,
    ActionButton,
  },

  props:{
    dataToShow:{
      type: Boolean,
      required: false,
      default: false
    },
        
    hobbieToEdit:{
      type:Object,
      required: false,
      default: null,
    },
  },

  data(){
    return {
      constants: Constants,
    };
  },

  methods:{
    close(){
      this.$emit('close');
    },

    chooseIcon(icon){
      this.$emit('changeIcon', icon);
      this.close();
    },

    removeIcon(){
      this.$emit('removeIcon');
      this.close();
    }
  },

  computed:{
    listIcons(){
      return Constants.icons;
    }
  }
};
</script>
